import React from 'react';
import ReactDOM from 'react-dom';
import MarkdownApp from './components/MarkdownApp';
import 'normalize.css/normalize.css';
import './sass/style.scss';

ReactDOM.render(<MarkdownApp />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js